import { render, staticRenderFns } from "./salesVolume.vue?vue&type=template&id=155cbe58&"
import script from "./salesVolume.vue?vue&type=script&lang=js&"
export * from "./salesVolume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports